<div class="border-stroke-neutral-medium rounded-md border bg-white">
  <div
    class="bg-components-background-neutral-lighter hover:bg-components-background-neutral-main group/item px-xs py-xxs flex h-[52px] cursor-pointer items-center justify-between rounded-t-md"
    [attr.aria-label]="titre()"
    [class]="{ 'rounded-b-md': !isOpen() }"
    (click)="toggle()"
    tabindex="0"
  >
    <div class="flex w-full items-center">
      <div class="size-md">
        @if (draggable()) {
          <div class="invisible cursor-move group-hover/item:visible">
            <ng-icon name="lucideGripVertical" hlmTooltipTrigger="Déplacer la phase" hlm size="sm" />
          </div>
        }
      </div>
      <div class="flex w-full items-center justify-between">
        <div class="flex items-center">
          <div class="flex">
            <ng-content select="iconLeft" />
            <span class="component-medium-semibold">{{ titre() }}</span>
          </div>
          <ng-content select="chipLeft" />
        </div>
        <ng-content select="chipRight" />
      </div>
    </div>
    <div class="flex items-center gap-2">
      @if (actions().length > 1) {
        <button
          class="invisible group-hover/item:visible group-focus/item:visible focus:visible"
          [hlmDropdownMenuTrigger]="actionsMenu"
          (click)="$event.stopPropagation()"
          hlmBtn
          variant="ghost"
          size="icon"
        >
          <ng-icon name="lucideEllipsisVertical" />
        </button>

        <ng-template #actionsMenu>
          <hlm-dropdown-menu>
            @for (action of actions(); track $index) {
              <button
                [hidden]="action.invisible ? action.invisible(item()) : false"
                (triggered)="action.action(item())"
                hlmDropdownMenuItem
              >
                <ng-icon [name]="action.icon" hlmMenuIcon />
                {{ action.label }}
                @if (action.shortcut) {
                  <hlm-dropdown-menu-shortcut>{{ action.shortcut }}</hlm-dropdown-menu-shortcut>
                }
              </button>
            }
          </hlm-dropdown-menu>
        </ng-template>
      } @else if (actions().length === 1) {
        @let action = actions()[0];
        <button
          [hidden]="action.invisible ? action.invisible(item()) : false"
          [hlmTooltipTrigger]="action.label"
          [class]="action.class"
          (click)="action.action(item()); $event.stopPropagation()"
          hlmBtn
          variant="ghost"
        >
          <ng-icon [name]="action.icon" hlm size="sm" />
        </button>
      }
      <button
        [attr.aria-label]="(isOpen() ? 'Plier' : 'Déplier') + ' le bloc'"
        [hlmTooltipTrigger]="(isOpen() ? 'Plier' : 'Déplier') + ' le bloc'"
        (click)="$event.stopPropagation(); toggle()"
        hlmBtn
        variant="ghost"
        size="icon"
        type="button"
      >
        <ng-icon class="collapse-icon" [class.rotated]="isOpen()" name="lucideChevronDown" />
      </button>
    </div>
  </div>
  @if (isOpen()) {
    <div class="border-stroke-neutral-medium border-t" @expandCollapse>
      <ng-content />
    </div>
  }
</div>
